exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rounded-border[data-v-3575074f] {\n  border-radius: 0.25rem !important;\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n  background-color: white !important;\n}\n", ""]);

// exports
